import { ConfirmationService } from 'primeng/api';
import { Component, OnInit, ViewChildren, QueryList, ViewChild, Input, ViewEncapsulation } from '@angular/core';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { Table } from 'primeng/table';
import { TabPanelHandler } from '@core/_utils/table.utils';
import { CommonService } from '@service/common.service';
import { RequestTools } from '@service/request.tools';
import { concatAllBasket, formatDataBskSens, formatDataSensBsk, getBasketLabel, getBasketList } from '@core/_utils/tools.utils';
import { Tools } from '@service/tools';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, lastValueFrom, map } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'app-list-resbsk',
    templateUrl: './list-resbsk.component.html',
    styleUrls: ['./list-resbsk.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ListResBskComponent extends TabPanelHandler implements OnInit {
    public value = true;
    public itemConfirm: ItemConfirmComponent;
    public requests = [];
    public requestList = [];
    public basketList = [];
    public sens = '';
    private basketName = [];

    protected _isInRangeTimeout: any;

    public listColumns = [];

    @ViewChildren('p-tabPanel:not(:first-child)')
    public itemChildren: QueryList<any>;

    @ViewChild('dt')
    public dataTable: Table;
    public blockEvent = false;
    public libSens: string;

    @Input()
    public entities: Array<any> = [];

    constructor(
        private api: ApiV6Service,
        private requestTools: RequestTools,
        public tools: Tools,
        public menu: MenuServiceInt,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        protected translate: TranslateService
    ) {
        super(translate);
        this.menu.display = true;
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.listColumns = [
            { header: this.translate.instant('Name'), field: 'label' },
        ];
        this.sens = 'b';
        this.changeView(null);
        this.commonService.checkReset();
    }

    setFilteredList(event) {}

    public changeView(event) {
        if (this.sens === 'b') {
            this.libSens = this.translate.instant('View_BskRes');
            this.sens = 'r';
        } else {
            this.sens = 'b';
            this.libSens = this.translate.instant('View_ResBsk');
        }
        this.findAll(this.sens);
    }

    private async findAll(aSens) { 
        let wRes: any = {};
        let wBskList: any;
        try {
            wRes.data = await lastValueFrom(this.readReqBskData(aSens));
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        this.requestList = [...wRes.data.getRequestList.data];
        wBskList = this.tools.getBasketTransfert(wRes.data.getBasketList, null, false, null, null, null);
        this.prepareBskList(wBskList);
        this.prepareData(wRes.data.getReqBskList.data, aSens);
    }

    private readReqBskData(aSens) {
        let wRequest = 'getresbaskets';
        if (aSens === 'b') {
            wRequest = 'getbasketsres';
        }
        return forkJoin([
            this.api.execUrlAction(wRequest,''),
            this.api.getResultPrepare('getresults', ''),
            this.requestTools.getBasketList('')]).pipe(
            map(([getReqBskList, getRequestList, getBasketList]) => {
                return { getReqBskList, getRequestList, getBasketList };
            })
        );
    }

    private prepareData(aList, aSens) {
        if (aSens === 'r') {
            this.prepareReqBsk(aList);
        } else {
            this.prepareBskReq(aList);
        }   
    }

    private prepareBskList(aBskList) {
        this.basketList = concatAllBasket(
            aBskList.wBasketMailList,
            aBskList.wBasketCollectList,
            aBskList.wBasketPublishList,
            aBskList.wBasketActionList,
            aBskList.wBasketInputList,
            aBskList.wBasketOutputList,
            aBskList.wBasketSystemList
        );
        this.basketName = getBasketList(this.basketList);
    }

    private prepareReqBsk(aList) {
        this.requests = aList.map((item) => {
            item.reference = item.id_base;
            item.bsklabel = getBasketLabel(this.basketName, item.bskname, 'name');
            return item;
        });
        this.requests = formatDataSensBsk(this.requests, 'id_base');
    }

    private prepareBskReq(aList) {
        this.requests = aList.map((item) => {
            item.reference = item.bskname;
            item.bsklabel = getBasketLabel(this.basketName, item.bskname, 'name');
            return item;
        });
        this.requests = formatDataBskSens(this.requests, 'id_base');
    }

    closeTab(event) {
        this.closeTabsheet(event);
        this.index = event.index - 1;
        this.execClose(event);
    }

    validateTab(event) {
        this.addTab(event);
    }

    public async addTab(event) {
        let wRes: any = {};
        if (event.create === true) {
            this.closeTabsheet(this._event);
            this.index = this.index - 1;
        } else {
            this.closeTab(event);
        }
        wRes = await this.execReload(this.sens);   
    }

    deleteTab(event) {
        this.requests = this.requests.filter((item) => {
            return item.id !== event.data.id;
        });
        this.requests = [...this.requests];
        this.closeTab(event);
    }

    cancelAdd(event) {
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    handleChange($event) {
        this.index = $event.index;
    }

    confirmDelete(event) {
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_DelA', {label: event.item._label}),
            () => {
                this.delete(event);
            }
        );
    }

    public async delete(event)  {
        let wRes: any = {};
        try {
            await lastValueFrom(this.api.execUrlAction('deleteresbsk', event.data.id));
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return;
        }
        wRes = await this.execReload(this.sens);        
        this.closeTab(event);
    }

    private async execReload(aSens) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.readReqBskData(aSens));
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        this.prepareData(wRes.data.getReqBskList.data, aSens);
    }

    showDetails(item) {
        if (this.sens === 'b') {
            return;
        }
        item = item.data;
        if (!this.isAlreadySelected(item.id)) {
            this.addElement(item.id, item.name, item.reference);
        }
    }

    showDetailsExpand(item) {
        if (!this.isAlreadySelected(item.id)) {
            this.addElement(item.id, item.name, item.reference);
        }
    }

    sortReference(event: any): void {}

}

